// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       // Remove the results when they are no longer relevant for the new search term
//       // so they don't show up when the dropdown opens again
//       this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
//     }

//     // Update the term asap, don't wait for the predictive search query to finish loading
//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);

//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = '';
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       // Search term was changed from other search input, treat it as a user change
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();

//     switch (event.code) {
//       case 'ArrowUp':
//         this.switchOption('up');
//         break;
//       case 'ArrowDown':
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
//     const currentButtonText = searchForTextElement?.innerText;
//     if (currentButtonText) {
//       if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
//         // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     // Filter out hidden elements (duplicated page and article resources) thanks
//     // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
//     const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
//       (element) => element.offsetParent !== null
//     );
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = '';

//     if (!moveUp && selectedElement) {
//       activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute('aria-selected', true);
//     if (selectedElement) selectedElement.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(' ', '-').toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }

//     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
//       signal: this.abortController.signal,
//     })
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, 'text/html')
//           .querySelector('#shopify-section-predictive-search').innerHTML;
//         // Save bandwidth keeping the cache in all instances synced
//         this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
//           predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//         });
//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           // Code 20 means the call was aborted
//           return;
//         }
//         this.close();
//         throw error;
//       });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
//     this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', true);

//     this.setLiveRegionResults();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight =
//       window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute('open', true);
//     this.input.setAttribute('aria-expanded', true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//     }
//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', false);
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute('style');
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);

/**
 * PredictiveSearch — Fully self-contained custom element.
 * Does NOT extend SearchForm (fixes "SearchForm is not defined" error).
 * Matches the live dropdown UI shown in the reference screenshot.
 */
// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';
//     this.debounceTimer = null;
//     this.resultsMaxHeight = false;
//   }

//   connectedCallback() {
//     // Core elements
//     this.input = this.querySelector('input[type="search"], input[name="q"]');
//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.statusElement = this.querySelector('.predictive-search-status');
//     this.loadingText = this.getAttribute('data-loading-text') || 'Loading…';
//     this.allInstances = document.querySelectorAll('predictive-search');

//     if (!this.input || !this.predictiveSearchResults) {
//       console.warn('[PredictiveSearch] Required elements not found. Check your HTML structure.');
//       return;
//     }

//     this.setupEventListeners();
//   }

//   disconnectedCallback() {
//     this.abortController.abort();
//   }

//   setupEventListeners() {
//     // Form submit
//     if (this.input.form) {
//       this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
//       this.input.form.addEventListener('reset', this.onFormReset.bind(this));
//     }

//     // Input events
//     this.input.addEventListener('input', this.onInput.bind(this));
//     this.input.addEventListener('focus', this.onFocus.bind(this));

//     // Component-level events
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));

//     // Close button (X)
//     const closeBtn = this.querySelector('[data-predictive-search-close], button[type="reset"]');
//     if (closeBtn) {
//       closeBtn.addEventListener('click', () => this.close(true));
//     }
//   }

//   // ─── Input Handling ────────────────────────────────────────────────────────

//   onInput() {
//     clearTimeout(this.debounceTimer);
//     this.debounceTimer = setTimeout(() => this.onChange(), 300);
//   }

//   onChange() {
//     const newSearchTerm = this.getQuery();

//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
//     }

//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);
//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   // ─── Form Events ──────────────────────────────────────────────────────────

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
//       event.preventDefault();
//     }
//   }

//   onFormReset() {
//     this.searchTerm = '';
//     this.abortController.abort();
//     this.abortController = new AbortController();
//     this.close(true);
//   }

//   // ─── Focus Events ─────────────────────────────────────────────────────────

//   onFocus() {
//     const currentSearchTerm = this.getQuery();
//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   // ─── Keyboard Events ──────────────────────────────────────────────────────

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);

//     switch (event.code) {
//       case 'ArrowUp':
//         event.preventDefault();
//         this.switchOption('up');
//         break;
//       case 'ArrowDown':
//         event.preventDefault();
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//       case 'Escape':
//         this.close();
//         this.input.blur();
//         break;
//     }
//   }

//   onKeydown(event) {
//     if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
//       event.preventDefault();
//     }
//   }

//   // ─── Option Navigation ────────────────────────────────────────────────────

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     const allVisibleElements = Array.from(
//       this.querySelectorAll('li, button.predictive-search__item')
//     ).filter((el) => el.offsetParent !== null);

//     if (!allVisibleElements.length) return;
//     if (moveUp && !selectedElement) return;

//     let selectedIndex = -1;
//     for (let i = 0; i < allVisibleElements.length; i++) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedIndex = i;
//         break;
//       }
//     }

//     if (this.statusElement) this.statusElement.textContent = '';

//     let activeIndex = 0;
//     if (!moveUp && selectedElement) {
//       activeIndex = selectedIndex === allVisibleElements.length - 1 ? 0 : selectedIndex + 1;
//     } else if (moveUp) {
//       activeIndex = selectedIndex === 0 ? allVisibleElements.length - 1 : selectedIndex - 1;
//     }

//     if (activeIndex === selectedIndex) return;

//     const activeElement = allVisibleElements[activeIndex];
//     activeElement.setAttribute('aria-selected', 'true');
//     if (selectedElement) selectedElement.setAttribute('aria-selected', 'false');
//     this.input.setAttribute('aria-activedescendant', activeElement.id || '');
//   }

//   selectOption() {
//     const selected = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
//     if (selected) selected.click();
//   }

//   // ─── Search API ───────────────────────────────────────────────────────────

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }

//     // Build URL — works with Shopify's routes object or falls back gracefully
//     const baseUrl =
//       (typeof routes !== 'undefined' && routes.predictive_search_url) ||
//       '/search/suggest';

//     fetch(
//       `${baseUrl}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
//       { signal: this.abortController.signal }
//     )
//       .then((response) => {
//         if (!response.ok) throw new Error(response.status);
//         return response.text();
//       })
//       .then((text) => {
//         const parsed = new DOMParser().parseFromString(text, 'text/html');
//         const section = parsed.querySelector('#shopify-section-predictive-search');

//         if (!section) {
//           console.warn('[PredictiveSearch] Could not find #shopify-section-predictive-search in response.');
//           this.close();
//           return;
//         }

//         const resultsMarkup = section.innerHTML;

//         // Sync cache across all instances on the page
//         this.allInstances.forEach((inst) => {
//           inst.cachedResults[queryKey] = resultsMarkup;
//         });

//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         if (error.name === 'AbortError') return; // intentional abort, not an error
//         console.error('[PredictiveSearch] Fetch error:', error);
//         this.close();
//       });
//   }

//   // ─── Live Region ──────────────────────────────────────────────────────────

//   setLiveRegionLoadingState() {
//     if (!this.statusElement) return;
//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', 'true');
//   }

//   setLiveRegionText(text) {
//     if (!this.statusElement) return;
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = text;
//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   // ─── Rendering ────────────────────────────────────────────────────────────

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', 'true');
//     this.setLiveRegionResults();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     const countEl = this.querySelector('[data-predictive-search-live-region-count-value]');
//     if (countEl) this.setLiveRegionText(countEl.textContent);
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     if (!previousTerm) return;
//     const el = this.querySelector('[data-predictive-search-search-for-text]');
//     if (!el) return;

//     const text = el.innerText;
//     const matches = text.match(new RegExp(previousTerm, 'g'));
//     if (!matches || matches.length > 1) return;

//     el.innerText = text.replace(previousTerm, newTerm);
//   }

//   // ─── Open / Close ─────────────────────────────────────────────────────────

//   getResultsMaxHeight() {
//     const header =
//       document.querySelector('.section-header') ||
//       document.querySelector('header') ||
//       document.querySelector('.header-wrapper') ||
//       document.querySelector('[class*="header"]');

//     const bottom = header ? header.getBoundingClientRect().bottom : 60;
//     this.resultsMaxHeight = window.innerHeight - bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     const maxH = this.resultsMaxHeight || this.getResultsMaxHeight();
//     this.predictiveSearchResults.style.maxHeight = `${maxH}px`;
//     this.setAttribute('open', 'true');
//     this.input.setAttribute('aria-expanded', 'true');
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//       this.searchTerm = '';
//     }

//     const selected = this.querySelector('[aria-selected="true"]');
//     if (selected) selected.setAttribute('aria-selected', 'false');

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', 'false');
//     this.resultsMaxHeight = false;
//     this.predictiveSearchResults.removeAttribute('style');
//     this.isOpen = false;
//   }
// }

// // Only define once — avoids "already defined" errors on hot-reload
// if (!customElements.get('predictive-search')) {
//   customElements.define('predictive-search', PredictiveSearch);
// }


/**
 * PredictiveSearch — Fully self-contained custom element.
 * Does NOT extend SearchForm (fixes "SearchForm is not defined" error).
 * Matches the live dropdown UI shown in the reference screenshot.
 */



class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.debounceTimer = null;
    this.resultsMaxHeight = false;
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"], input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.statusElement = this.querySelector('.predictive-search-status');
    this.loadingText = this.getAttribute('data-loading-text') || 'Loading…';
    this.allInstances = document.querySelectorAll('predictive-search');

    if (!this.input || !this.predictiveSearchResults) {
      console.warn('[PredictiveSearch] Required elements not found.');
      return;
    }

    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  setupEventListeners() {
    if (this.input.form) {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
    }

    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

  
    if (this.isMobile) {
      this.input.addEventListener('touchstart', () => {
        if (this.getQuery().length) this.onFocus();
      }, { passive: true });
    }

    if (this.isMobile) {
      this._onDocumentTouch = (e) => {
        if (!this.contains(e.target)) this.close();
      };
      document.addEventListener('touchstart', this._onDocumentTouch, { passive: true });
    } else {
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    const closeBtn = this.querySelector('[data-predictive-search-close], button[type="reset"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close(true));
    }
  }


  onInput() {
    clearTimeout(this.debounceTimer);
    const delay = this.isMobile ? 400 : 300;
    this.debounceTimer = setTimeout(() => this.onChange(), delay);
  }

  onChange() {
    const newSearchTerm = this.getQuery();

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  getQuery() {
    return this.input.value.trim();
  }

 

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    }
  }

  onFormReset() {
    this.searchTerm = '';
    this.abortController.abort();
    this.abortController = new AbortController();
    this.close(true);
  }


  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }


  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);

    switch (event.code) {
      case 'ArrowUp':
        event.preventDefault();
        this.switchOption('up');
        break;
      case 'ArrowDown':
        event.preventDefault();
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
      case 'Escape':
        this.close();
        this.input.blur();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(
      this.querySelectorAll('li, button.predictive-search__item')
    ).filter((el) => el.offsetParent !== null);

    if (!allVisibleElements.length) return;
    if (moveUp && !selectedElement) return;

    let selectedIndex = -1;
    for (let i = 0; i < allVisibleElements.length; i++) {
      if (allVisibleElements[i] === selectedElement) {
        selectedIndex = i;
        break;
      }
    }

    if (this.statusElement) this.statusElement.textContent = '';

    let activeIndex = 0;
    if (!moveUp && selectedElement) {
      activeIndex = selectedIndex === allVisibleElements.length - 1 ? 0 : selectedIndex + 1;
    } else if (moveUp) {
      activeIndex = selectedIndex === 0 ? allVisibleElements.length - 1 : selectedIndex - 1;
    }

    if (activeIndex === selectedIndex) return;

    const activeElement = allVisibleElements[activeIndex];
    activeElement.setAttribute('aria-selected', 'true');
    if (selectedElement) selectedElement.setAttribute('aria-selected', 'false');
    this.input.setAttribute('aria-activedescendant', activeElement.id || '');
  }

  selectOption() {
    const selected = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selected) selected.click();
  }

 

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const baseUrl =
      (typeof routes !== 'undefined' && routes.predictive_search_url) ||
      '/search/suggest';

    fetch(
      `${baseUrl}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const section = parsed.querySelector('#shopify-section-predictive-search');

        if (!section) {
          console.warn('[PredictiveSearch] Could not find #shopify-section-predictive-search in response.');
          this.close();
          return;
        }

        const resultsMarkup = section.innerHTML;
        this.allInstances.forEach((inst) => {
          inst.cachedResults[queryKey] = resultsMarkup;
        });

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('[PredictiveSearch] Fetch error:', error);
        this.close();
      });
  }

 
  setLiveRegionLoadingState() {
    if (!this.statusElement) return;
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', 'true');
  }

  setLiveRegionText(text) {
    if (!this.statusElement) return;
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = text;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', 'true');
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const countEl = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (countEl) this.setLiveRegionText(countEl.textContent);
  }

  updateSearchForTerm(previousTerm, newTerm) {
    if (!previousTerm) return;
    const el = this.querySelector('[data-predictive-search-search-for-text]');
    if (!el) return;

    const text = el.innerText;
    const matches = text.match(new RegExp(previousTerm, 'g'));
    if (!matches || matches.length > 1) return;

    el.innerText = text.replace(previousTerm, newTerm);
  }

  

  getResultsMaxHeight() {
    const header =
      document.querySelector('.section-header') ||
      document.querySelector('header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('[class*="header"]');


    if (this.isMobile) {
      this.resultsMaxHeight = window.screen.height * 0.5;
      return this.resultsMaxHeight;
    }

    const bottom = header ? header.getBoundingClientRect().bottom : 60;
    this.resultsMaxHeight = window.innerHeight - bottom;
    return this.resultsMaxHeight;
  }

  open() {
    const maxH = this.resultsMaxHeight || this.getResultsMaxHeight();
    this.predictiveSearchResults.style.maxHeight = `${maxH}px`;

  
    if (this.isMobile) {
      this.predictiveSearchResults.style.overflowY = 'auto';
      this.predictiveSearchResults.style.webkitOverflowScrolling = 'touch';
      this.predictiveSearchResults.style.position = 'absolute';
      this.predictiveSearchResults.style.zIndex = '9999';
      this.predictiveSearchResults.style.width = '100%';
      this.predictiveSearchResults.style.left = '0';
    }

    this.setAttribute('open', 'true');
    this.input.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.searchTerm = '';
    }

    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', 'false');

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', 'false');
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
    this.isOpen = false;
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}